import React, { useEffect } from 'react';
import {
  ANALYTICS_EVENT,
  ANALYTICS_PROPERTY,
  IntegrationName,
} from '@kouto/types';
import { analyticsManager } from 'features/analytics';
import { DeadLinkRecovery } from 'components/organisms/DeadLinkRecovery';

// Every not-found experience, event, resource or collection page lands here. Recovery shows
// bookable alternatives, or the plain screen when there are none.
const NotFoundExperience = () => {
  useEffect(() => {
    // Set before the error fires so page_stop_error, the recovery view and card clicks all carry it.
    analyticsManager.setAppData({
      [ANALYTICS_PROPERTY.PageType]: 'Experience not found page',
    });
    analyticsManager.sendEvent(
      ANALYTICS_EVENT.PAGE_STOP_ERROR,
      {
        [ANALYTICS_PROPERTY.ErrorCode]: '404',
        [ANALYTICS_PROPERTY.ErrorMessage]: 'experience_not_found',
      },
      { providers: [IntegrationName.ADOBE_ANALYTICS] },
    );
  }, []);

  return <DeadLinkRecovery />;
};

export default NotFoundExperience;
